import React from "react"
import { storyblokEditable } from "@storyblok/react"

import { useStaticQuery, graphql } from "gatsby"
import { getImage } from "gatsby-plugin-image"

import { LkfNewsListing, LkfNewsTeaser } from "gatsby-theme-gba"

const LkfNewsListingEditable = ({ blok }) => {
  const defaultLang = process.env.GATSBY_DEFAULT_LANG
    ? process.env.GATSBY_DEFAULT_LANG
    : "de"
  const lkfNews = useStaticQuery(graphql`
    query LkfNewsListing {
      file(relativePath: { eq: "lkf-news-listing.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      allFile(filter: { id: { regex: "/(?:.*)lkfNewsListing/" } }) {
        edges {
          node {
            id
            name
            childImageSharp {
              gatsbyImageData(
                width: 791
                quality: 80
                breakpoints: [432, 791]
                layout: CONSTRAINED
              )
            }
          }
        }
      }
      newsQuery: allStoryblokEntry(
        sort: { sort_by_date: DESC }
        filter: {
          default_full_slug: { regex: "/^lkf-news/" }
          is_startpage: { eq: false }
        }
      ) {
        nodes {
          uuid
          tag_list
          lang
          name
          full_slug
          content
          published_at
          sort_by_date
          first_published_at(formatString: "YYYY-MM-DD")
          translated_slugs {
            lang
            path
          }
        }
      }
    }
  `)

  const todayDate = new Date()
  const dd = String(todayDate.getDate()).padStart(2, "0")
  const mm = String(todayDate.getMonth() + 1).padStart(2, "0")
  const yyyy = todayDate.getFullYear()

  const today = `${yyyy}-${mm}-${dd}`

  let filteredFiles = lkfNews.allFile.edges.filter(function (projectFile) {
    if (!blok.image || !projectFile.node.id.includes(blok.image.substring(1))) {
      return false // skip
    }

    return true
  })
  let imageFile = filteredFiles[0]
    ? getImage(filteredFiles[0].node)
    : blok.image

  const filterLang =
    blok.currentLanguage === defaultLang ? "default" : blok.currentLanguage

  let lkfNewsList = lkfNews.newsQuery.nodes.filter(
    (node) => node.name !== "news"
  )

  const currentLanguageListingPage = lkfNewsList.filter(
    (node) => node.lang === filterLang
  )

  let customFallbackLang = currentLanguageListingPage ? filterLang : "en"

  const lkfTeasers = lkfNewsList.filter((node) => {
    return (
      node.content &&
      node.lang === customFallbackLang &&
      node.first_published_at <= today
    )
  })

  return (
    <div {...storyblokEditable(blok)} key={blok._uid}>
      <LkfNewsListing
        heading={blok.heading || "Headline"}
        image={imageFile || lkfNews.file.childImageSharp.gatsbyImageData}
        imageAlt={blok.imageAlt}
        noEntries={blok.noEntries || 2}
        noEntriesText={blok.noEntriesText}
        buttonMoreNews={blok.buttonMoreNews}
        buttonLessNews={blok.buttonLessNews}
        linkTarget={blok.linkTarget}
        currentLanguage={blok.currentLanguage}
      >
        {lkfTeasers.map((teaser, index) => {
          let content = JSON.parse(teaser.content)
          return (
            <LkfNewsTeaser
              key={index}
              heading={content.body[0].headline}
              date={teaser.sort_by_date || teaser.first_published_at}
              currentLanguage={blok.currentLanguage}
            >
              {content.body[0].body}
            </LkfNewsTeaser>
          )
        })}
      </LkfNewsListing>
    </div>
  )
}

export default LkfNewsListingEditable
